import { ShareIconAnimation } from "common/Icons/Icons";
import styled, { useTheme } from "styled-components";

const AnimatedShareIcon = (props: any) => {
  const theme = useTheme();
  return <StyledIcon {...props} fill={theme.colors.primaryBlue} />;
};

export default AnimatedShareIcon;

const StyledIcon = styled(ShareIconAnimation)`
  #eir8jFunxeA2_ts {
    animation: eir8jFunxeA2_ts__ts 2221.153846153846ms linear infinite normal
      forwards;
  }
  @keyframes eir8jFunxeA2_ts__ts {
    0% {
      transform: translate(16.499585px, 16px) scale(0, 0);
    }
    15.151515% {
      transform: translate(16.499585px, 16px) scale(0, 0);
    }
    63.203463% {
      transform: translate(16.499585px, 16px) scale(6.7, 6.7);
    }
    100% {
      transform: translate(16.499585px, 16px) scale(6.7, 6.7);
    }
  }
  #eir8jFunxeA2 {
    animation: eir8jFunxeA2_f_o 2221.153846153846ms linear infinite normal
      forwards;
  }
  @keyframes eir8jFunxeA2_f_o {
    0% {
      fill-opacity: 1;
    }
    15.151515% {
      fill-opacity: 1;
    }
    63.203463% {
      fill-opacity: 0;
    }
    100% {
      fill-opacity: 0;
    }
  }
  #eir8jFunxeA3_ts {
    animation: eir8jFunxeA3_ts__ts 2221.153846153846ms linear infinite normal
      forwards;
  }
  @keyframes eir8jFunxeA3_ts__ts {
    0% {
      transform: translate(16.499585px, 16px) scale(1, 1);
    }
    11.255411% {
      transform: translate(16.499585px, 16px) scale(1.05, 1.05);
    }
    17.316017% {
      transform: translate(16.499585px, 16px) scale(0.8, 0.8);
    }
    21.645022% {
      transform: translate(16.499585px, 16px) scale(1.03, 1.03);
    }
    25.974026% {
      transform: translate(16.499585px, 16px) scale(0.98, 0.98);
    }
    29.87013% {
      transform: translate(16.499585px, 16px) scale(1, 1);
    }
    100% {
      transform: translate(16.499585px, 16px) scale(1, 1);
    }
  }
`;
